<template>
  <div class="feasibility-project-page">
    <!-- <div class="breadcrumbs-wrapper">
      <p>
        <router-link to="">Messenger</router-link>
      </p>
    </div> -->
    <GlobalMessenger />
    <FAQ />
  </div>
</template>

<script>
import GlobalMessenger from "@/components/chat/GlobalMessenger.vue";
import FAQ from "@/components/chat/FAQ.vue";

export default {
  components: { GlobalMessenger, FAQ },
};
</script>
